import React from "react";
import PropTypes from "prop-types";
import { CircularProgress, FormControlLabel, Switch } from "@mui/material";
import { CM_TOOLTIPS } from "./utils/tooltipsContent";

const ScheduledImportToggle = ({
  enabled,
  onChange,
  saving = false,
  disabled = false,
  className = "",
}) => (
  <div className={`cm-scheduled-import-toggle${className ? ` ${className}` : ""}`.trim()}>
    {saving && (
      <CircularProgress className="cm-scheduled-import-spinner" size={16} aria-label="Salvataggio in corso" />
    )}
    <FormControlLabel
      className="cm-scheduled-import-switch"
      control={(
        <Switch
          size="small"
          checked={Boolean(enabled)}
          disabled={saving || disabled}
          onChange={(event) => onChange(event.target.checked)}
        />
      )}
      label="Import schedulato"
      title={CM_TOOLTIPS.scheduledImportEnabled}
    />
  </div>
);

ScheduledImportToggle.propTypes = {
  enabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  saving: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default ScheduledImportToggle;
